import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Auth.module.css';
import { forgotPassword } from '../../../api/user/auth';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Failed to send reset email. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.backgroundAnimation}></div>

      <div className={`${styles.authCard} ${styles.userCard}`}>
        <div className={styles.authHeader}>
          <div className={styles.authLogo}>SPOTFLI</div>
          <h2 className={styles.authTitle}>Forgot Password</h2>
          <p className={styles.authSubtitle}>
            {success
              ? 'Check your inbox for the reset link'
              : "Enter your email and we'll send you a reset link"}
          </p>
        </div>

        {error && (
          <div className={styles.errorMessage}>
            <i className={`fa fa-exclamation-circle ${styles.errorIcon}`}></i>
            {error}
          </div>
        )}

        {success ? (
          <div className={styles.authLinks} style={{ marginTop: 0, paddingTop: 0, borderTop: 'none' }}>
            <i className="fa fa-check-circle" style={{ color: '#1e9ff2', fontSize: '3rem', display: 'block', marginBottom: '16px' }}></i>
            <p style={{ color: '#5b6b78', marginBottom: '20px' }}>
              A password reset link has been sent to <strong>{email}</strong>
            </p>
            <Link to="/login" className={styles.authLink}>Back to Sign In</Link>
          </div>
        ) : (
          <form className={styles.authForm} onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label className={styles.formLabel} htmlFor="email">Email Address</label>
              <input
                className={styles.formInput}
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your.email@example.com"
                required
              />
            </div>

            <button className={styles.authButton} type="submit" disabled={isLoading}>
              {isLoading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <div className={styles.authLinks}>
              <span>Remember your password? </span>
              <Link to="/login" className={styles.authLink}>Sign In</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
